module.exports = __webpack_public_path__ + "static/img/img_3.4d0a8cc8.jpg";